import { render, staticRenderFns } from "./controlRecord.vue?vue&type=template&id=0338f6c8&scoped=true"
import script from "./controlRecord.vue?vue&type=script&lang=js"
export * from "./controlRecord.vue?vue&type=script&lang=js"
import style0 from "./controlRecord.vue?vue&type=style&index=0&id=0338f6c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338f6c8",
  null
  
)

export default component.exports